import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CaremapNotesModelFactory } from '../notes/model/CaremapNotesModelFactory';
import { useSubscription } from '@meraki-internal/state';
import { EditCommunityPostWithQueryParamDrawer } from './EditCommunityPostWIthQueryParamDrawer';
import { IAction, Menu } from '../components/Menu';
import { DeleteIcon, EditIcon } from '../theme/Icons';

export const CommunityPostMenu: FC<{postId: string}> = ({ postId }) => {
    const editPostDrawer = useInstance(EditCommunityPostWithQueryParamDrawer);

    const notesFactory = useInstance(CaremapNotesModelFactory);
    useSubscription(() => notesFactory);

    const model = notesFactory.forActiveCaremap();
    const post = model.getNote(postId);

    if (!post) {
        return;
    }

    const actions: IAction[] = [];
    if (model.canEdit(post)) {
        actions.push({
            Icon:
            EditIcon,
            text: `Edit Post`,
            handler: () => editPostDrawer.open({ noteId: post.noteId })
        });
    }

    if (model.canDelete(post)) {
        const deletePost = () => {
            model.deleteNote(post);
            editPostDrawer.close();
        };
        actions.push({
            Icon: DeleteIcon,
            role: 'destructive',
            text: `Delete Post`,
            handler: deletePost,
            'data-type': 'delete-button'
        });
    }

    return (
        <>
            {actions.length > 0 && (
                <div style={{display: 'flex', justifyContent: 'space-between', marginTop: -18}}>
                    <div style={{flexGrow: 1}}>&nbsp;</div>
                    <div>
                        <Menu data-id="view-post-actions" actions={actions} />
                    </div>
                </div>
            )}
        </>
    );
};
